import { MemberPortalRoutes } from 'constants/route.constants';
import { ReactComponent as ShareIcon } from 'img/icons/share.svg';
import { ReactComponent as CalendarIcon } from 'img/icons/calendar.svg';
import { ReactComponent as DocumentChartIcon } from 'img/icons/document-chart.svg';
import { ReactComponent as ClubsIcon } from 'img/icons/sidebar/dumbbell.svg';
import { RouteItem } from 'types/route.types';
import { RouteItemId } from 'common/enums/html.enums';
import commonMessages from 'common/messages/messages';

export const memberPortalRouteItems: RouteItem[] = [
  {
    type: 'navLink',
    id: RouteItemId.RouteItemBtnProfile,
    path: MemberPortalRoutes.PROFILE,
    title: commonMessages.profileHeader,
    icon: ShareIcon,
    iconViewBox: '0 0 20 20',
  },
  {
    type: 'navLink',
    id: RouteItemId.RouteItemBtnBookingCalendar,
    path: MemberPortalRoutes.BOOKING,
    title: commonMessages.booking,
    icon: CalendarIcon,
    iconViewBox: '0 0 20 20',
  },
  {
    type: 'navLink',
    id: RouteItemId.RouteItemBtnReportOverview,
    path: MemberPortalRoutes.REPORTS,
    title: commonMessages.reports,
    icon: DocumentChartIcon,
    iconViewBox: '0 0 20 20',
  },
  {
    type: 'navLink',
    id: RouteItemId.RouteItemBtnClubs,
    path: MemberPortalRoutes.CLUBS,
    title: commonMessages.clubsLabel,
    icon: ClubsIcon,
    iconViewBox: '0 0 20 20',
  },
];
